import React, { useEffect, FC, useState, useMemo } from "react";
import { Table, Button, Input, Checkbox } from "antd";
import { YHModal } from "@/components/YHModal";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { useRepairTemplateDetailsModel, IMaterialDetailModel } from "./repairTemplateDetailsModels";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { bigNumber, formatIntPoint, formatNum, formatIntPoint1 } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import { ISalesTypeEnum, IPriceTypeEnum, IServiceNatureCodeType } from "@/types/ScmEnums";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const MaterialModal: FC<RouterParamType> = ({ materialCode, mode }) => {
    const { shopAndOrg: { shopId }, user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        materialModel: visible,
        setMaterialModel,
        searchWorkMaterialData,
        workMaterialDataSource,
        addDataMaterialSource,
        initPgCfg,
        workMaterialPgCfg,
        detailAddForm,
        detailEditForm,
        workMaterialloadData,
        resetWorkMaterialloadData,
        setSearchWorkMaterialData,
        setAddDataMaterialSource,
        detailMaterialEditList,
        detailMaterialAddList,
        setWorkMaterialDataSource,
        transformsToPoMaterialDetailList
    } = useRepairTemplateDetailsModel();
    const [checked, setChecked] = useState(true);
    const checkedList = mode === "edit" ? detailMaterialEditList : detailMaterialAddList
    const onOk = () => {
        transformsToPoMaterialDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setMaterialModel(false);
        setAddDataMaterialSource([]);
        setSearchWorkMaterialData({})
    };
    useEffect(() => {
        if (visible) {
            workMaterialloadData(initPgCfg, {}, mode)
        }
    }, [visible])

    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,

        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,

        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: true,
        },
        // {
        //     title: '价格',
        //     width: 100,
        //     dataIndex: 'price',
        //     editable: true,

        // },
        // {
        //     title: '总计',
        //     width: 100,
        //     dataIndex: 'amount',
        // }
        , {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => add(record)}
                    disabled={(addDataMaterialSource?.find(item => item.materialCode === record.materialCode) || checkedList?.find((item: any) => item.materialCode === record.materialCode)) ? true : false}
                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })




    const add = async (record: IMaterialDetailModel) => {
        setAddDataMaterialSource([...addDataMaterialSource, {
            ...record,
            amount: +bigNumber.times((record.num as number), (record.price as number)).toFixed(2)
        }])
    }

    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataMaterialSource.filter(item => item.materialCode != record.materialCode)
        setAddDataMaterialSource(filterAddDataSource)
    }
    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, price, availableStock, purchasePrice, latestPurPrice } = row;
        num = +formatNum(num);
        price = +formatNum(price);
        let newRow = {
            ...row,
            num,
            amount: +bigNumber.times((num as number), (price as number)).toFixed(2)
        }
        const index = workMaterialDataSource.findIndex((item: any) => row.materialCode === item.materialCode);
        const item = workMaterialDataSource[index];
        workMaterialDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkMaterialDataSource([...workMaterialDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, price, availableStock, purchasePrice, latestPurPrice } = row;
        num = +formatNum(num);
        price = +formatNum(price);
        let newRow = {
            ...row,
            num,
            amount: +bigNumber.times((num as number), (price as number)).toFixed(2)
        }
        const index = addDataMaterialSource.findIndex((item) => row.materialCode === item.materialCode);
        const item = addDataMaterialSource[index];
        addDataMaterialSource.splice(index, 1, { ...item, ...newRow });
        setAddDataMaterialSource([...addDataMaterialSource])
    }
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkMaterialData.code}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkMaterialData({ ...searchWorkMaterialData, code: e.target.value }) }}
            onBlur={(e) => { setSearchWorkMaterialData({ ...searchWorkMaterialData, code: e.target.value?.trim() }) }}
            onPressEnter={() => workMaterialloadData(initPgCfg)}
            placeholder="商品编码"
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkMaterialData.name}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkMaterialData({ ...searchWorkMaterialData, name: e.target.value?.trim() }) }}
            onPressEnter={() => workMaterialloadData(initPgCfg)}
            placeholder="商品名称"
        />
        <Button onClick={() => workMaterialloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">检索</Button>
        <Button onClick={() => resetWorkMaterialloadData()} shape="round">重置</Button>
    </div>

    return <YHModal
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        title="维修模版管理-选择配件"
        width={'70%'}
        bodyHeight={730}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "5px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.materialCode as string}
                columns={newSelectColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workMaterialDataSource}
                pagination={{
                    ...workMaterialPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workMaterialloadData({ pageNum, pageSize }).then();
                    }
                }}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.materialCode as string}
                columns={newSelectColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={addDataMaterialSource}
                pagination={false}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}